.atm_3f_1fz0aif{border:1px solid #CED3DA;}
.atm_5j_1y44olf{border-radius:4px;}
.atm_l8_1f10cpp{padding:6px 8px;}
.atm_26_nnnoag{background:rgba(255, 255, 255, 0.3);}
.atm_9s_1txwivl{display:flex;}
.atm_9j_tlke0l{cursor:pointer;}
.atm_26_1j28jx2{background:transparent;}
.atm_l8_idpfg4{padding:0;}
.atm_e2_1ns9ob4{height:fit-content;}
.atm_1tgqd35_1j28jx2:hover{background:transparent;}
